<template>
  <div class="page-wrapper">


    <search-group title="" @search="findData" @clear="clearValue" :span="24" :btnOffset="18" :btnSpan="6"
                  :multipleLines="false" :inline="true"
                  style="padding: 0"
    >
      <Row class="mb16" :gutter="16">
        <Col span="6">
          <Select v-model="searchData.projectFid" placeholder="项目名称">
            <Option value=''>请选择</Option>
            <Option v-for="(item,index) in projectList" :value="item.value" :key="'keyB'+index">{{item.text}}</Option>
          </Select>
        </Col>
        <Col span="5">
          <Select v-model="searchData.businessCode" placeholder="费用项">
                        <Option value=''>请选择</Option>
                        <Option v-for="(item,index) in typeList" :value="item.value" :key="'keyB2'+index">{{item.text}}</Option>
          </Select>
        </Col>
        <Col span="5">

          <DatePicker type="month"
                      v-model="searchData.belongToMonth"
                      format="yyyy-MM"
                      placeholder="归属月份" style="display: block"></DatePicker>
        </Col>
        <!-- <Col span="8">
          <DatePicker style="width:100%" v-model="searchData.createTime" split-panels type="daterange" format="yyyy-MM-dd"
                      placeholder="成本记账日期"></DatePicker>
        </Col> -->

      </Row>
      <!-- <Row class="mb16" :gutter="16">


        <Col span="6">
          <Input placeholder="请搜索摘要、预算项、财务科目" v-model="searchData.condition"></Input>
        </Col>
      </Row> -->
    </search-group >
    <div style="padding-top: 0;">
      <Button v-p="{api:'incomeCostItem/cost/batchImport'}" type="primary" @click.stop="importN++" class="mb16">导入</Button>

      <Button v-p="{api:'incomeCostItem/downloadPolymerizationCostList'}" type="primary" :loading = "btnLoading" @click="exportFile()" class="mb16" style="margin-left:10px">导出</Button>
    </div>
    <table-list
      class="mt12"
      :columns="columns"
      :data="data"
      :current="current"
      :total="total"
      :loading="loading"
      @change-page="changPage"
    ></table-list>
    <import-file
    :i="importN"
    @done="getData"
    ></import-file>


  </div>
</template>

<script type="text/ecmascript-6">
  import SearchGroup from 'components/SearchGroup/index';
  import {formatDateTime} from "@/utils/format";
  import TableList from 'components/TableList/index';
import {businessCodecondition,downloadPolymerizationCostList,listPolymerization} from "api/gop";
import {getProjects} from "@/api/common";
import {formatMoney} from "@/utils/format";
  import ImportFile from './components/ImportFile'

  export default {
    name:'cost',
    components: {
      SearchGroup,
      TableList,
      ImportFile
    },
    props: {
      // projectList:{
      //   type:Array,
      //   default:()=>{return []}
      // }
    },
    mounted() {
      this.findData()
      businessCodecondition({type:1}).then(res=>{
        if(!res.data){
          return
        }
        this.typeList=res.data
      }).catch(error=>{
      })
      getProjects().then(res => {
        if(!res.data){
          return
        }
        this.projectList = res.data

      }).catch(error => {
      })
    },
    computed: {
      searchDataComputed() {
        function f(data) {
          return data ? formatDateTime(data, false) : ''
        }
        return {
          // condition:this.searchData.condition,
          projectFid: this.searchData.projectFid,
          // startHappenDate: f(this.searchData.createTime[0]),
          // endHappenDate:f(this.searchData.createTime[1]),
          businessCode:this.searchData.businessCode,
          belongToMonth:f(this.searchData.belongToMonth).slice(0,7),
        }
      }
    },
    data() {
      return {

        importN:0,
        projectList:[],
        typeList:[],
        cN:0,
        fid:'',
        costMoney:null,
        value:null,
        searchParams:null,
        data: [],
        columns: [
          {
            type: 'index',
            width: 60,
            align: 'center'
          },
          {
            title: ' '
          },
          {
            title: '项目名称 ',
            align: 'center',
            key: 'projectName',
            width: 120,
          },
          {
            title: ' '
          },
          {
            title: '费用项 ',
            align: 'center',
            key: 'businessName',
            width: 120,
            // render:(h,params)=>{
            //   return h('a',{
            //     on:{
            //       click:()=>{
            //         let query = {
            //           fid: params.row['fid'],
            //         };
            //         this.$router.push({name:'personbookinfo',query:query})
            //       }
            //     }
            //   },params.row['fcode'])
            // }
          },

          {
            title: ' '
          },
          {
            title: "目标金额 ",
            align: 'center',
            key: 'targetAmount',
            width: 120,
            render:(h,params)=>{
              return h('span',{},formatMoney(params.row['targetAmount']))
            }
          },
          {
            title: ' '
          },
          {
            title: "实际金额 ",
            align: 'center',
            key: 'costMoney',
            width: 120,
            render:(h,params)=>{
              return h('span',{},formatMoney(params.row['costMoney']))
            }
          },
          {
            title: ' '
          },
          // {
          //   title: '金额',
          //   align: 'center',
          //   key: 'costMoney',
          //   width: 160,
          //   render:(h,params)=>{
          //     return h('span',{},formatMoney(params.row['costMoney']))
          //   }
          // },


          // {
          //   title: ' '
          // },

          // {
          //   title: "发生日期",
          //   align: 'center',
          //   key: 'happenDate',
          //   width: 120,
          //   render:(h,params)=>{
          //     return h('span',{},formatDateTime(params.row['happenDate'],false))
          //   }
          // },
          // {
          //   title: ' '
          // },

          // {
          //   title: "记账日期",
          //   align: 'center',
          //   key: 'accountDate',
          //   width: 120,
          //   render:(h,params)=>{
          //     return h('span',{},formatDateTime(params.row['accountDate'],false))
          //   }
          // },
          // {
          //   title: ' '
          // },
          // {
          //   title: "财务科目",
          //   align: 'center',
          //   key: 'feeName',
          //   width: 160,
          // },
          // {
          //   title: ' '
          // },
          // {
          //   title: "摘要",
          //   align: 'center',
          //   key: 'summary',
          //   width: 140,
          //   render: (h, params) => {
          //     if (params.row['summary'] && params.row['summary'].length > 7) {
          //       return h('Tooltip', {
          //         props: {
          //           placement: "top"
          //         }
          //       }, [
          //         h('div', {
          //           style: {
          //             whiteSpace: 'normal'
          //           },
          //           slot: 'content',
          //         }, params.row['summary']),
          //         h('span', {}, params.row['summary'].slice(0, 7) + '...')


          //       ])

          //     } else {
          //       return h('span', {}, params.row['summary'])
          //     }
          //   }
          // },

          // {
          //   title: ' '
          // },

          {
            title: "冲减金额",
            align: 'center',
            key: 'deductionAmount',
            width: 120,
            render:(h,params)=>{
              return h('span',{},formatMoney(params.row['deductionAmount']))
            }
          },
          {
            title: ' '
          },        {
            title: "归属月份 ",
            align: 'center',
            key: 'belongToMonth',
            width: 120,
          },
          {
            title: ' '
          },
          {
            title: '操作',
            align: 'center',
            key: 'action',
            width: 170,
            fixed: 'right',
            render: (h, params) => {
              return h('div', [
                h('a', {
                  style: {
                    marginRight: '5px'
                  },
                  // directives:[
                  //   {
                  //     name:'p',
                  //     value:{
                  //       api:'incomeCostItem/cost/deduct'
                  //     }
                  //   }
                  // ],
                  on:{
                    click: ()=>{
                      this.$router.push({
                        name: 'checkcost', params:
                        {
                          projectFid:params.row['projectFid'],
                          belongToMonth:params.row['belongToMonth'],
                          businessCode:params.row['businessCode'],
                        }
                      })
                    }
                  }
                }, '查看'),


              ])
            }
          }
        ],
        total: 0,
        current: 1,
        loading: false,
        metaList:[],
        page:1,
        limit:10,
        searchData: {
          projectFid: '',
          // createTime: ['', ''],
          // condition:'',
          businessCode:'',
          belongToMonth:new Date(new Date().setMonth(new Date().getMonth(), 1)),
        },
        btnLoading:false,
      }
    },
    methods: {


      exportFile(){
        let data = {};
        for (let key in this.searchParams) {
          if(key==='page' || key==='limit') continue;
          data[key] = this.searchParams[key]
        }
        this.btnLoading = true;
        downloadPolymerizationCostList(data).then( res => {
          if(res.headers.count > 10000){
            this.btnLoading = false;
            this.$Modal.info({
              title: '导出合同',
              content:'上限10000条，请选择条件后下载'
            });
          } else{
            let filename = res.headers.filename || 'excel.xls';
            let blob = new Blob([res.data]);
            let url = window.URL.createObjectURL(blob);
            let link = document.createElement('a');
            link.style.display = 'none';
            link.href = url;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            this.btnLoading = false
          }
        }).catch( err => {
          this.btnLoading = false;
          console.log(err)
        })
      },
      changeLoading() {
        this.loading2 = false;
        this.$nextTick(() => {
          this.loading2 = true
        })
      },
      getData(){
        let params={
          type:2,
          ...this.searchParams,
          page:this.page,
          limit:this.limit
        }
        listPolymerization(params).then(res=>{
          if(!res.data){
            return
          }
          this.total=res.data.total
          res.data.rows&& (this.data=res.data.rows)

        }).catch(error=>{
        })

      },
      changPage(n){
        this.current = n;
        this.page = n;
        this.getData()
      },
      findData() {
        this.searchParams=this.searchDataComputed
        this.page=1
        this.current=1
        this.getData()
      },
      clearValue() {
        this.searchData = {
          projectFid: '',
          // createTime: ['', ''],
          // condition:'',
          businessCode:'',
          belongToMonth:new Date(new Date().setMonth(new Date().getMonth(), 1)),
        }
      },
    },
  }
</script>

<style scoped>
  .width3 {
    width: 200px;
  }
</style>
